<template>
  <div class="allContent">
    <div class="game_title">
      <img src="../../assets/webActivity/homeTwoGame/test1.png" alt="" />
      <div>
        <img
          src="../../assets/webActivity/homeTwoGame/icon_dowland.png"
          alt=""
          @click="goGamedetails"
        />
      </div>
    </div>

    <!-- 活动抽奖 -->
    <activityLottery
      :lotteryNum="state.lotteryNum"
      :token="state.token"
      @getActivity="getActivity"
    />

    <!-- 任务信息 -->
    <!-- <taskInfo
      :video_url="state.gameVideo"
      :poster="state.gamePoster"
      :isLogin="state.isLogin"
      :isPay="state.isPay"
      :isPay68="state.isPay68"
      :isPay198="state.isPay198"
      :isPay648="state.isPay648"
      :otherLog="state.otherLog"
      :gameName="state.gameName"
      :activityStatus="state.activityStatus"
      :gid="state.gid"
    /> -->

    <taskInfo
      :video_url="state.gameVideo"
      :poster="state.gamePoster"
      :isLogin="state.isLogin"
      :isPay="state.isPay"
      :otherLog="state.otherLog"
      :gameName="state.gameName"
      :activityStatus="state.activityStatus"
      :gid="state.gid"
    />

    <!-- 游戏信息 -->
    <gameinfoSwiper :swiperList="state.gamePhoto" />
    <!-- 活动信息 -->
    <div class="activity_info">
      <activityInfo :myLog="state.myLog" />
    </div>

    <!-- 抽奖拼接 -->
    <!-- <lottery></lottery> -->
  </div>
</template>
<script setup>
import { onMounted, ref, reactive, nextTick } from "vue";

// 拆分组件
import activityInfo from "./homeGame/activityInfo";
import activityLottery from "./homeGame/activityLottery";
import taskInfo from "./homeGame/taskInfo.vue";
import gameinfoSwiper from "./homeGame/gameinfoSwiper.vue";

import { detect } from "@/utils/device";
import { getQueryString } from "@/utils/location";

import { getactivityInfo } from "@/api/activity";
import { Toast } from "vant";
import { setToken, getToken } from "@/utils/auth";

const state = reactive({
  gid: "790",
  token: "",
  activityInfo: {},
  gamePhoto: [],
  gameVideo: "",
  gamePoster: "",
  lotteryNum: 0,
  isLogin: 0,
  isPay: 0,
  isPay68: 0,
  isPay198: 0,
  isPay648: 0,
  otherLog: [],
  gameName: "",
  token: "",
  activityStatus: 0,
});

onMounted(() => {
  // 设置token
  if (getQueryString("token") != "undefined") {
    setToken(getQueryString("token"));
    state.token = getQueryString("token");
  } else {
    setToken(route.query.token);
    state.token = route.query.token;
  }
  // 初始化获取活动信息
  getActivity();
});

// 获取活动信息
const getActivity = () => {
  getactivityInfo({
    token: state.token,
  }).then((res) => {
    // console.log("获取到的活动信息-----------", res.data);
    if (res.data.code == 1) {
      state.activityInfo = res.data.data;
      state.gamePhoto = res.data.data.photo;
      state.gameVideo = res.data.data.videourl;
      state.gamePoster = res.data.data.videoimg;
      state.lotteryNum = res.data.data.cjcs;
      state.isLogin = res.data.data.isLogin;

      state.isPay = res.data.data.isPay;
      // state.isPay68 = res.data.data.isPay68;
      // state.isPay198 = res.data.data.isPay198;
      // state.isPay648 = res.data.data.isPay648;

      state.otherLog = res.data.data.lottery_log_other;
      state.gameName = res.data.data.gamename;
      state.myLog = res.data.data.lottery_log;
      state.gid = res.data.data.gid;
      state.activityStatus = res.data.data.status;
    } else {
      Toast(res.data.msg);
    }
  });
};

// 跳转到游戏详情页
const goGamedetails = () => {
  if (detect() == "android" || detect() == "harmony") {
    window.document.location = "gogame://" + state.gid;
  } else {
    var eventData = {
      eventType: "openEvent",
      gid: state.gid,
    };
    window.parent.postMessage(eventData, "*");
  }
  // console.log("跳转到游戏详情页--------",state.gid);
};
</script>
<style scoped>
.allContent {
  height: 100vh;
  overflow: auto;
  overflow-x: hidden;
  /* padding-bottom:100px; */
}
.allContent .game_title {
  height: 915px;
  width: 100%;
}
.game_title div {
  color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
}
.game_title div img {
  width: 357px;
  height: 160px;
}
img {
  height: 100%;
  width: 100%;
  vertical-align: bottom;
}

/* 活动信息 */
.activity_info {
  position: fixed;
  right: 0;
  bottom: 55%;
  z-index: 99;
}
.activity_info :deep(.van-popup) {
  background-color: rgba(0, 0, 0, 0);
}
.activity_info :deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.7);
}
.activity_info :deep(.van-checkbox__icon .van-icon) {
  border: 1px solid #fff;
}
</style>
